import React from "react";
import * as Styled from "./NewPlaylistAlert.styled";
import { TextInput } from "../../../libs";
import { BaseButton } from "../../../libs";
import { useFormik } from "formik";
import * as Yup from "yup";

export const NewPlaylistAlert: React.FC<{
    onClose: () => void;
    handleCreatePlaylist: (name: string) => void | Promise<void>;
    title?: string;
    confirmText?: string;
    placeholder?: string;
}> = ({
    onClose,
    handleCreatePlaylist,
    title = "New Playlist",
    confirmText = "Create",
    placeholder = "Playlist Name",
}) => {
    const formik = useFormik({
        initialValues: {
            playlist_name: ""
        },
        validationSchema: Yup.object({
            playlist_name: Yup.string()
                .required("This is a mandatory field. Please complete it before continuing.")
                .test("len", "Must be less than 100 characters", (val) => val?.length <= 100)
        }),
        onSubmit: async (values) => {
            await handleCreatePlaylist(values.playlist_name);
            onClose();
        }
    });
    return (<Styled.NewPlaylistAlertContainer>
        <Styled.NewPlaylistAlertTitle>{title}</Styled.NewPlaylistAlertTitle>
        <TextInput
            fieldName="playlist_name"
            hasError={!!formik.errors.playlist_name}
            fieldLabel="Title*"
            placeholder={placeholder}
            inputLimit={100}
            fieldValue={formik.values.playlist_name}
            onChangeHandler={formik.handleChange}
        />
        <Styled.ErrorText>{formik.errors.playlist_name}</Styled.ErrorText>
        <Styled.ButtonsContainer>
            <BaseButton size="sm" variant="secondary" onClick={onClose}>Cancel</BaseButton>
            <BaseButton
                size="sm"
                variant="primary"
                disabled={formik.isSubmitting}
                onClick={formik.submitForm}
            >
                {confirmText}
            </BaseButton>
        </Styled.ButtonsContainer>
    </Styled.NewPlaylistAlertContainer>);
}
